import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Item } from '../../../checkout/fragments/group-items/item-list'
import { Lines } from '../../components/line'
import TitleBox from '../../components/title-box'
import { FormattedMessage } from 'react-intl'

export default props => {
    useStyles(classes)
    const { checkoutItems } = props
    return <TitleBox
        noPadding
        extra={<span className={classes.Title}><FormattedMessage id="unpaid" defaultMessage="Unpaid" /></span>}
        title={<FormattedMessage id="items" defaultMessage="Item(s)" />}>
        <div className={classes.Items}>
            {
                checkoutItems?.map((item, index) => <div className={classes.Item} key={`${item.variantId}-${index}`}>
                    <Item item={{
                        ...item,
                        realPrice: item.price,
                        imageUrl: item.productImageUrl
                    }} />
                </div>)
            }
        </div>
    </TitleBox>
}